import React from "react";
import AttendanceSummaryCard from "./AttendanceSummaryCard";
import AttendanceStatusCard from "./AttendanceStatusCard";
import {
  CircleCheck,
  CircleAlert,
  LucideCircleX,
  LucidePlaneTakeoff,
} from "lucide-react";

const AttendanceOverview = ({ selectedDay, attendanceData }) => {

  const defaultData = [
    {
      type: "Present",
      count: 4,
      employees: [
        { name: "Ashley Palma", role: "Senior Developer", time: "08:45 AM" },
        { name: "John Doe", role: "Project Manager", time: "09:00 AM" },
        { name: "Emily Smith", role: "UI/UX Designer", time: "08:30 AM" },
        { name: "Michael Johnson", role: "Backend Developer", time: "09:15 AM" },
      ],
      icon: CircleCheck,
      color: "green",
    },
    {
      type: "Late",
      count: 2,
      employees: [
        { name: "Jane Doe", role: "Frontend Developer", time: "09:20 AM" },
        { name: "Tom Hardy", role: "QA Engineer", time: "09:05 AM" },
      ],
      icon: CircleAlert,
      color: "amber",
    },
    {
      type: "Absent",
      count: 1,
      employees: [{ name: "Alice Cooper", role: "Designer" }],
      icon: LucideCircleX,
      color: "red",
    },
    {
      type: "On Leave",
      count: 3,
      employees: [
        { name: "Robert Brown", role: "HR Manager", leaveType: "Sick Leave" },
        { name: "Lucy Liu", role: "Developer", leaveType: "Annual Leave" },
        { name: "Sam Wilson", role: "Analyst", leaveType: "Vacation Leave" },
      ],
      icon: LucidePlaneTakeoff,
      color: "blue",
    },
  ];

  const data = attendanceData || defaultData;

  return (
    <div className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
      <div className="flex flex-col text-left">
        <h2 className="label-gradient text-[20px] font-semibold">
          Attendance Overview
        </h2>
        <p>{selectedDay.format("dddd, MMMM D, YYYY")}</p>
      </div>

      <div className="grid grid-cols-4 gap-4">
        {data.map((item) => (
          <AttendanceSummaryCard
            key={item.type}
            type={item.type}
            count={item.count}
            icon={item.icon}
          />
        ))}
      </div>

      {data.map((item) => (
        <div key={item.type} className="mt-4">
          <div className="flex items-center gap-2 mb-2">
            <item.icon size={20} className={`text-${item.color}-600`} />
            <span className="font-semibold text-[16px]">
              {item.type} ({item.count})
            </span>
          </div>
          <AttendanceStatusCard employees={item.employees} statusType={item.type} />
        </div>
      ))}
    </div>
  );
};

export default AttendanceOverview;
